import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7b53a7dd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7b53a7dd&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b53a7dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b53a7dd')) {
      api.createRecord('7b53a7dd', component.options)
    } else {
      api.reload('7b53a7dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7b53a7dd&scoped=true", function () {
      api.rerender('7b53a7dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/7-1-pop-bar-1/index.vue"
export default component.exports